import React, { useState, useRef } from "react"
import { HidePasswordIcon, ViewPasswordIcon } from "../../../components/ThemeSvgs";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { maxBounds, minBounds, Patterns, VALIDATIONS_TEXT } from "../../../constants/Constants";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

const DeleteAccount = () => {
    const navigate = useNavigate();
    const [disable, setDisable] = useState(false);
    const [passwordShow, setPasswordShow] = useState(false);
    const [cPasswordShow, setCPasswordShow] = useState(false);
    const [nPasswordShow, setNPasswordShow] = useState(false);
    const { register, handleSubmit, watch, formState: { errors } } = useForm({
        mode: "onChange",
        criteriaMode: "firstError",
        shouldFocusError: true,
    });

    const passwordWatch = useRef({});
    passwordWatch.current = watch("yourPassword", "");


    const onSubmit = (data) => {
        setDisable(true);
        console.log("Forgot Password data:", data);
        toast.success('Your Account Has Been Deleted', {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });

        setTimeout(function () {
            //code goes here
            setDisable(false);
            /*
            * navigate after sending code to verification code screen
            * */
            navigate("/")
        }, 4000);

    };
    return (
        <>
            <div className="settingBoxWrapper">
                <Form onSubmit={handleSubmit(onSubmit)} autoComplete={"off"} className="settingUpdatePassword">
                    <div className="settingBoxHeader">
                        <div className="d-flex flex-column">
                            <h3 className="heading-small ">Delete Account</h3>
                            <p className="m-b-20 mt-1">For security reasons, we need you to kindly confirm your password <br />
                                before we proceed to delete your account.</p>
                            <Row>
                                <Col xs={12} sm={12} xl={4}>
                                    <Row>
                                        <Col xs={12} sm={12}>
                                            <Form.Group className="themeInputGroup passwordInput mb-3" controlId="resetPassword">
                                                <Form.Label>Your Password *</Form.Label>
                                                <InputGroup className={errors.resetPassword ? "hasError" : ""}>
                                                    <Form.Control
                                                        type={passwordShow ? "text" : "password"}
                                                        placeholder="••••••••"
                                                        aria-describedby="passToggle"
                                                        className={"passwordControl"}
                                                        minLength={minBounds.PASSWORD}
                                                        maxLength={maxBounds.PASSWORD}
                                                        autoComplete="off"
                                                        role={"presentation"}
                                                        {...register("yourPassword", {
                                                            required: {
                                                                value: true,
                                                                message: VALIDATIONS_TEXT.PASSWORD_REQUIRED
                                                            },
                                                            pattern: {
                                                                value: Patterns.Password,
                                                                message: VALIDATIONS_TEXT.PASSWORD_PATTERN,
                                                            },
                                                            minLength: {
                                                                value: minBounds.PASSWORD,
                                                                message: VALIDATIONS_TEXT.PASSWORD_MIN
                                                            },
                                                            maxLength: {
                                                                value: maxBounds.PASSWORD,
                                                                message: VALIDATIONS_TEXT.PASSWORD_MAX
                                                            }
                                                        })}
                                                    />
                                                    <Button type={"button"} className={"btn-togglePassword"} variant="outline-secondary" onClick={() => setPasswordShow(!passwordShow)}>
                                                        {
                                                            passwordShow ? <HidePasswordIcon /> : <ViewPasswordIcon />
                                                        }
                                                    </Button>
                                                </InputGroup>

                                                {errors.yourPassword && <Form.Text>{errors.yourPassword.message}</Form.Text>}
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} sm={12}>
                                            <Form.Group className="themeInputGroup passwordInput mb-3" controlId="resetCPassword">
                                                <Form.Label>Confirm Password *</Form.Label>
                                                <InputGroup className={errors.resetCPassword ? "hasError" : ""}>
                                                    <Form.Control
                                                        type={cPasswordShow ? "text" : "password"}
                                                        placeholder="••••••••"
                                                        aria-describedby="passToggle"
                                                        className={"passwordControl"}
                                                        minLength={minBounds.PASSWORD}
                                                        maxLength={maxBounds.PASSWORD}
                                                        autoComplete="off"
                                                        role={"presentation"}
                                                        {...register("confirmPassword", {
                                                            required: {
                                                                value: true,
                                                                message: VALIDATIONS_TEXT.PASSWORD_REQUIRED
                                                            },
                                                            pattern: {
                                                                value: Patterns.Password,
                                                                message: VALIDATIONS_TEXT.PASSWORD_PATTERN,
                                                            },
                                                            validate: value => value === passwordWatch.current || "The passwords do not match",
                                                            minLength: {
                                                                value: minBounds.PASSWORD,
                                                                message: VALIDATIONS_TEXT.PASSWORD_MIN
                                                            },
                                                            maxLength: {
                                                                value: maxBounds.PASSWORD,
                                                                message: VALIDATIONS_TEXT.PASSWORD_MAX
                                                            }
                                                        })}
                                                    />
                                                    <Button type={"button"} className={"btn-togglePassword"} variant="outline-secondary" onClick={() => setCPasswordShow(!cPasswordShow)}>
                                                        {
                                                            cPasswordShow ? <HidePasswordIcon /> : <ViewPasswordIcon />
                                                        }
                                                    </Button>
                                                </InputGroup>

                                                {errors.confirmPassword && <Form.Text>{errors.confirmPassword.message}</Form.Text>}
                                            </Form.Group>
                                        </Col>

                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="myProfile__footer">
                        <Button type={"submit"} className={"btn-submit m-t-50 glowBtn"} disabled={disable ? true : false}>
                            {
                                !disable ? <>Confirm</> : <div className="load black"></div>
                            }
                        </Button>
                    </div>
                </Form>
            </div >
        </>
    )
}

export default DeleteAccount